"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_EVENT_QUEUE_SIZE = exports.NULL_SENTINEL = exports.SESSION_ASSIGNMENT_CONFIG_LOADED = exports.BASE_URL = exports.REQUEST_TIMEOUT_MILLIS = void 0;
exports.REQUEST_TIMEOUT_MILLIS = 5000;
exports.BASE_URL = 'https://fscdn.eppo.cloud/api';
exports.SESSION_ASSIGNMENT_CONFIG_LOADED = 'eppo-session-assignment-config-loaded';
exports.NULL_SENTINEL = 'EPPO_NULL';
// number of logging events that may be queued while waiting for initialization
exports.MAX_EVENT_QUEUE_SIZE = 100;
//# sourceMappingURL=constants.js.map